<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>

              <v-row>
                <v-col cols="5">
                  <label style="margin:10px; text-align:right">시작일</label>
                </v-col>
                <v-col cols="6">
                  <datetime input-style="margin-left:10px; width:150px; border-bottom:1px solid gray; text-align:left; font-size:16px"
                            type="date" format="yyyy-MM-dd" title="시작일" value-zone="local"
                            v-model="editedItem.START_DATE" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="5">
                  <label style="margin:10px; text-align:right">종료일</label>
                </v-col>
                <v-col cols="6">
                  <datetime input-style="margin-left:10px; width:150px; border-bottom:1px solid gray; text-align:left; font-size:16px"
                            type="date" format="yyyy-MM-dd" title="종료일" value-zone="local"
                            v-model="editedItem.END_DATE" />
                </v-col>
              </v-row>

              <v-row dense class="mb-1">
                <label style="color:red">{{$t('eventfund_label1')}}</label>
              </v-row>
              <v-row dense>
                <v-text-field :disabled="editedItem.ISREFUND == 0" :rules="[value => !value || !/[^0-9.]/.test(value) || this.$t('eventfund_label7')]" outlined v-model="editedItem.RATE" :label="$t('eventrefund_col2')"></v-text-field>
              </v-row>

              <v-row dense>
                <v-select outlined hide-details @change="changerefund"
                  v-model="editedItem.ISREFUND" :items="STATELIST" :label="$t('eventrefund_col3')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>




    <v-row align="center" justify="start" dense>
      <v-col cols="12" md="3" sm="6" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>      
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" class="pa-0" align="center">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col cols="12" md="3" class="pa-0" align="center">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="6" md="1" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
    </v-row>

    <v-row align="center" justify="start" dense>
      <v-col cols="12"> 
        <label style="color:red">{{ $t('eventfund_msg9') }}</label>
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer

        class="datatablestyle"
        item-key="REFPOLICY_IDX"
        :loading="loading"
        :items-per-page="9999"
        >
        <template v-slot:header.START_DATE>
          <label class="cheader_normal" >시작일</label>
        </template>
        <template v-slot:header.END_DATE>
          <label class="cheader_normal" >종료일</label>
        </template>
        <template v-slot:header.RATE>
          <label class="cheader_normal" >{{$t("eventrefund_col2")}}</label>
        </template>
        <template v-slot:header.ISREFUND>
          <label class="cheader_normal" >{{$t("eventrefund_col3")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eventrefund_col4")}}</label>
        </template>

        <template v-slot:item.START_DATE="{ item }">
          <label style="text-align: center">{{formatDate(item.START_DATE)}}</label>
        </template>
        <template v-slot:item.END_DATE="{ item }">
          <label style="text-align: center">{{formatDate(item.END_DATE)}}</label>
        </template>
        <template v-slot:item.RATE="{ item }">
          <label>{{item.RATE}}%</label>
        </template>
        <template v-slot:item.ISREFUND="{ item }">
          <template v-if="item.ISREFUND == 0">
            <label>{{$t('eventfund_label4')}}</label>
          </template>
          <template v-else>
            <label>{{$t('eventfund_label5')}}</label>
          </template>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import moment from 'moment'
import dateFormat from 'dateformat'
export default {
    data: () => ({

      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          START_DATE:dateFormat(new Date(), "yyyy-mm-dd"),
          END_DATE:dateFormat(new Date(), "yyyy-mm-dd"),
          RATE:100,
          ISREFUND:1,
      },
      editedItem: {
      },

      STATELIST: [
          {name:'환불불가', name2:"Non-refundable",  value:0}
        , {name:'환불가능', name2:"Refundable",    value:1}
      ],

      //테이블 정의
      headers: [
        {text: '시작일',    value: 'START_DATE', sortable: true, align:'center' },
        {text: '종료일',    value: 'END_DATE', sortable: true, align:'center' },
        {text: '환불(%)',   value: 'RATE', sortable: true, align:'center'},
        {text: '환불가능여부',  value: 'ISREFUND', sortable: true, align:'center'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      formatDate(date){
        if(!date) return '';
        return moment(date).format("YYYY-MM-DD");
      },

      changerefund(cl){
        if(cl == 0){
          this.editedItem.RATE = "0";
        }
      },

      loadpage(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화

        this.loading = true;

          this.$http.post(this.$host+'/api/EventRefpolicyList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              list.forEach(element => {
                  this.itemList.push(element); 
              });
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      async save () {

        if(this.editedItem.START_DATE  == undefined || this.editedItem.START_DATE.length < 1){
          this.$alert(this.$t('eventfund_msg10'));
          return;
        }
        if(this.editedItem.END_DATE  == undefined || this.editedItem.END_DATE.length < 1){
          this.$alert(this.$t('eventfund_msg11'));
          return;
        }
        if(this.editedItem.START_DATE > this.editedItem.END_DATE){
          this.$alert(this.$t('eventfund_msg12'));
          return;
        }
        if(this.editedItem.RATE  == undefined || String(this.editedItem.RATE).length < 1){
          this.$alert(this.$t('eventfund_msg5'));
          return;
        }
        const rateVal = /[^0-9.]/g;
        if(rateVal.test(this.editedItem.RATE)){
          this.$alert(this.$t('eventfund_msg6'));
          return;
        }
        if(this.editedItem.RATE < 0 || this.editedItem.RATE > 100){
          this.$alert(this.$t('eventfund_msg7'));
          return;
        }

        // 날짜 범위 중복 체크
        const newStart = this.editedItem.START_DATE.substring(0, 10);
        const newEnd = this.editedItem.END_DATE.substring(0, 10);

        for(let i = 0; i < this.itemList.length; i++){
          // 수정 시 자기 자신은 제외
          if(this.editedIndex > -1 && this.editedIndex == i) continue;

          const existStart = this.itemList[i].START_DATE.substring(0, 10);
          const existEnd = this.itemList[i].END_DATE.substring(0, 10);

          // 날짜 범위가 겹치는지 체크: A시작 <= B종료 AND A종료 >= B시작
          if(newStart <= existEnd && newEnd >= existStart){
            this.$alert(this.$t('eventfund_msg13'));
            return;
          }
        }

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/EventRefpolicyUpdate',{
                START_DATE: dateFormat(this.editedItem.START_DATE, "yyyy-mm-dd")
              , END_DATE: dateFormat(this.editedItem.END_DATE, "yyyy-mm-dd")
              , RATE: this.editedItem.RATE
              , ISREFUND: this.editedItem.ISREFUND
              , REFPOLICY_IDX: this.editedItem.REFPOLICY_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/EventRefpolicyInsert',{
                START_DATE: dateFormat(this.editedItem.START_DATE, "yyyy-mm-dd")
              , END_DATE: dateFormat(this.editedItem.END_DATE, "yyyy-mm-dd")
              , RATE: this.editedItem.RATE
              , ISREFUND: this.editedItem.ISREFUND
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage();
      },
      
      //신규 추가
      newinsert(){

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)

        this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.editedItem.START_DATE = moment(item.START_DATE).format("YYYY-MM-DD");
        this.editedItem.END_DATE = moment(item.END_DATE).format("YYYY-MM-DD");
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventRefpolicyDelete',{
              REFPOLICY_IDX:item.REFPOLICY_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          

      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>